import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { Button, Divider, message, Popconfirm, Select, Space, Spin, Table, Tooltip } from "antd";
import { EditOutlined, SearchOutlined, EyeOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import SearchComponent from "../SearchComponent";

export default function Groups_License({ }) {
    const [users, setUser] = useState([]);
    const [ProcessedData, setProcessedData] = useState([]);
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    const [errors, setErrors] = useState({});
    const [actionPlans, setActionPlans] = React.useState([]);
    const [masterState, setMasterState] = useState([]);
    const [groups, setGroups] = useState();
    const [orgName, setOrgName] = useState([]);
    const [storedValue, setStoredValue] = useState(null);

    const columns = React.useMemo(() => [
        {
            title: "license_group Name",
            dataIndex: "group_name",
            key: "group_name",
        },
        {
            title: "Organisation Name",
            dataIndex: "o_name",
            key: "o_name",
        },
        {
            title: "License Validity",
            dataIndex: "license Validity",
            key: "license_Validity ",
            render: (text, record) => {
                let date = moment(record.license_validity);
                let now = moment();
                let diff = date.diff(now, "days");
                if (diff > -1) {
                    return (
                        <>
                            <Tooltip title={moment(record.license_validity).format("DD-MM-YYYY HH:mm:ss")}>
                                <span style={{ color: "green" }}>
                                    {diff} days left to expire
                                </span>
                            </Tooltip>
                        </>
                    );
                } else {
                    return (
                        <>
                            <Tooltip title={moment(record.license_validity).format("DD-MM-YYYY HH:mm:ss")}>
                                <span style={{ color: "red" }}>Expired</span>
                            </Tooltip>
                        </>
                    );
                }
            },
        },
        {
            title: "License Count",
            dataIndex: "license_count",
            key: "license_Count",
        },
        {
            title: "Operation",
            dataIndex: "operation",
            render: (_, record) => (
                ProcessedData.length >= 1 ? (
                    <>
                        <Space>
                            <Button
                                icon={<EditOutlined />}
                                onClick={() => {
                                    navigate(
                                        `/home/groups_license/update/${record.group_id}?type=edit&oId=${record?.o_id}`,
                                    );
                                }}
                                type="primary"
                                style={{ background: "orange", borderColor: "orange" }}
                            >
                                Edit{" "}
                            </Button>
                            <Popconfirm
                                title="All the attached licenses will be detached, and the group will be deleted."
                                onConfirm={() => handleDelete(record)}
                                disabled={record?.group_id === null || record?.group_id === 0}
                            >
                                <Button type="primary" disabled={record?.group_id === null || record?.group_id === 0} danger>
                                    Delete
                                </Button>
                            </Popconfirm>
                        </Space>
                    </>
                ) : null)
        },
    ]);


    function getGrpdata() {
        setLoading(true)
        axios
            .get(`/generic-api/get-all-group`)
            .then((res) => {
                setUser(res.data?.data);
                const data = res.data.data;
                setProcessedData(data)
                setMasterState(data);
                setActionPlans(data);
                setLoading(false)
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error);
                    message.error(`${error.response?.status} Error ${error.response?.data?.detail}`)
                } else {
                    console.log(error);
                    message.error(error?.message);
                }
            });
    }

    const getOrgNames = () => {
        axios.get("/generic-api/get_organisations")
            .then((res) => {
                setOrgName(res.data.data)
            }).catch((error) => {
                if (error.response) {
                    console.log(error);
                    message.error(`${error.response?.status} Error ${error.response?.data?.detail}`)
                } else {
                    console.log(error);
                    message.error(error?.message);
                }
            });
    }

    const getGRPNamesORG = (o_id) => {
        axios.get(`/generic-api/get-all-group-by-o-id?o_id=${o_id}`)
            .then((res) => {
                const data = res.data.data;
                setProcessedData(data)
                setMasterState(data);
            }).catch((error) => {
                if (error.response) {
                    console.log(error);
                    message.error(`${error.response?.status} Error ${error.response?.data?.detail}`)
                } else {
                    console.log(error);
                    message.error(error?.message);
                }
            });
    }

    const setDetailsKey = (key, value) => {
        setGroups((d) => ({
            ...d,
            [key]: value,
        }));
    };

    const onSubmit = (e) => {
        e.preventDefault();
        navigate("/home/groups/add?type=add");

    };

    useEffect(() => {
        getOrgNames();
    }, []);


    useEffect(() => {
        const stored = sessionStorage.getItem('grp_o_id');
        const stored_name = sessionStorage.getItem('grp_o_name');
        if (stored) {
            getGRPNamesORG(stored);
            setStoredValue(stored_name);
        } else {
            sessionStorage.removeItem('grp_o_name');
            sessionStorage.removeItem('grp_o_id');
            getGrpdata()
        }
    }, []);


    const handleDelete = (record) => {
        axios
            .delete(`/generic-api/license-group-delete?group_id=${record.group_id} `)
            .then((res) => {
                sessionStorage.removeItem('grp_o_name');
                message.success(record.group_name + " deleted successfully") &&
                    getGrpdata()
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error);
                    message.error(`${error.response?.status} Error ${error.response?.data?.detail}`)
                } else {
                    console.log(error);
                    message.error(error?.message);
                }
            });
    };


    // const onSelect = (data) => {
    //     sessionStorage.setItem('grp_o_name', data.label);
    //     sessionStorage.setItem('grp_o_id', data.value);
    //     setDetailsKey("grp_o_id", data.value)
    // };

    const handleSelect = (value, option) => {
        // console.log(value, option);
        if (!value) {
            // Cleared
            sessionStorage.removeItem('grp_o_name');
            sessionStorage.removeItem('grp_o_id');
            setStoredValue(null);
            getGrpdata();
        } else {
            // Selected
            sessionStorage.setItem('grp_o_name', option.label);
            sessionStorage.setItem('grp_o_id', value);
            setStoredValue(option);
            getGRPNamesORG(value);
        }
    };

    // const storedOId = sessionStorage.getItem('grp_o_id');
    // const storedOName = sessionStorage.getItem('grp_o_name');
    return (
        <>
            <header className="flex justify-between items-center" style={{ padding: "5px" }}>
                <p className="my-form-title">License_Groups</p>
                <Button
                    onClick={onSubmit}
                    type="primary"
                    style={{ margin: 1, float: "right", }}
                    className="bg-sky-600 font-bold">Add</Button>
            </header>
            <Divider />
            <div className="flex justify-between items-center">

                <Space.Compact>
                    <Select
                        showSearch
                        value={storedValue || "Select Organisation"}
                        onChange={(storedOId, storedOName) => handleSelect(storedOId, storedOName)}
                        style={{ width: 200, marginLeft: "10px", marginTop: "10px" }}
                        options={orgName?.map((items) => ({
                            value: items.o_id,
                            label: items.o_name,
                        }))}
                        allowClear
                        filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </Space.Compact>
                <SearchComponent
                    masterState={masterState}
                    state={actionPlans}
                    setState={setActionPlans}
                    searchOptions={[
                        { keyName: "group_name", label: "Group Name" },
                        { keyName: "o_name", label: "Organisation Name" },
                        { keyName: "license_limit", label: "License Limit" },
                    ]}
                />
            </div>
            <div className='my-form-outer mt-0'>
                <div style={{ position: 'relative', textAlign: 'right' }}>
                    <Table loading={loading}
                        columns={columns}
                        dataSource={actionPlans}
                        size="small"
                        pagination={{
                            position: ["bottomRight"],
                            showSizeChanger: true,
                        }}
                    />
                </div>
            </div>
        </>
    );
}